import React, { Component } from 'react'

export default class Ci extends Component {
    render() {
        return (
            <main className="page-main-pal container">
                <div className="alocolumns clearfix">
                    <div className="column main">
                    <div className="product-view">
                        <div className="product-essential">
                        <div className="row">
                            <div className="product media product-img-box clearfix col-md-5 col-sm-5 col-xs-12">
                            <div className="gallery-placeholder _block-content-loading" data-gallery-role="gallery-placeholder">
                                <img alt="main product" className="gallery-placeholder__image" src="https://zollwebstore.com/media//myDevices/images/AEDPro_1.jpg" />
                            </div>
                            </div>
                            <div className="product-info-main product-shop col-md-7 col-sm-7 col-xs-12">
                            <div className="product-info-price">
                                <div className="page-title-wrapper">
                                    {/* ganti judul product detail */}
                                <h1 className="page-title">
                                    <span className="base" data-ui-id="page-title-wrapper">ZOLL AED Pro</span>
                                </h1>
                                </div>
                                <span data-role="amhideprice-hide-button" id="amhideprice-product-id-314-1040" style={{display: 'none !important'}} />
                            </div>
                            <div className="product attribute overview">
                                {/* ganti product description product detail */}
                                <div className="value" itemProp="description">
                                    <p>ZOLL AED Pro for medical rescuers</p>
                                    <p>
                                    ZOLL AED Pro dirancang untuk mendukung Bantuan Hidup Dasar (BHD) dan Bantuan Hidup Lanjut (BHL). Perangkat ini memberikan panduan bagi penyelamat BHD, namun juga menyediakan kemampuan yang lebih canggih bagi tenaga penyelamat profesional, termasuk teknologi Real CPR Help® yang memberikan umpan balik kompresi nyata untuk meningkatkan kualitas CPR, serta layar LCD resolusi tinggi untuk visualisasi EKG.
                                    </p>
                                    <h2><strong>Fitur ZOLL AED Pro</strong></h2>
                                    <ul>
                                        <li>
                                            Panduan Real CPR Help
                                        </li>
                                        <li>
                                            Teknologi See-Thru CPR
                                        </li>
                                        <li>
                                            Layar LCD Resolusi Tinggi
                                        </li>
                                        <li>
                                            Desain Tangguh
                                        </li>
                                        <li>
                                            Mode Operasi Fleksibel
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>    
                    </div>
                </div>
            </main>
        )
    }
}
